<h1>Visit <a [href]="cbUrl">BigFuture</a>
  to learn about the Net Price of College</h1>
<p></p>
<h2>You can search a list of schools that use the College Board Net Price Calculator<br>by selecting
  <a href="https://bigfuture.collegeboard.org/pay-for-college/tools-calculators#"><strong>The College Board's Net Price
      Calculator</strong></a> on
  <a href="https://bigfuture.collegeboard.org/pay-for-college/tools-calculators#">this page.</a>
  </h2>
<p></p>
<p><em>Redirecting to Bigfuture...</em></p>